module.exports = __webpack_public_path__ + "img/s4-1.9d67346e.jpg";